import {
  MDBBtn,
  MDBBtnGroup,
  MDBCard,
  MDBCardBody,
  MDBCheckbox,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBIcon,
  MDBInput,
  MDBInputGroup,
  MDBTimepicker,
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import remove from "../components/images/remove.svg";
import CallRouteDevice from "./CallRouteDevice";
import PopupLoader from "../views/popups/PopupLoader";
import AddCRDevice from "../views/popups/users/AddCRDevice";
import { useFieldArray } from "react-hook-form";
import PopupLoaderNew from "../views/popups/PopupLoaderNew";

export default function CallSequence({ item, seqIndex, onCloneSeq, onCloneSeqEnd, size, onDelSeq, register, getValues, setValue, control, isadd, setAllowSaveFlag, deviceExternalNum, callerids, unregister, isDisabled, reset, dirtyFields, watch, seqList, errors, clearErrors, emptyDeviceIndex, setemptyDeviceIndex, setEMessage }) {
  const { t, i18n } = useTranslation();

  console.log("seq interation :::: " + JSON.stringify(item));
  console.log("===================================================================")
  const navigate = useNavigate();
  const [callRoute, setCallRoute] = useState({});
  const [addDevice, setAddDevice] = useState(false);
  const [devices, setDevices] = useState([])
  const [isOpen, setIsOpen] = useState(false);
  const [ringtime, setRingtime] = useState(item.ringtime);
  const [devIndex, setDevIndex] = useState(-1);
  const [routePlanName, setRoutePlanName] = useState("");
  const addDeviceRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);

  function handleClick() {
    addDeviceRef.current.click();
  }
  const { fields: deviceFields, append: deviceAppend, remove: deviceRemove } = useFieldArray({
    control,
    name: `sequences.${seqIndex}.devices`
  });
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  function toggleAddDevice(e) {
    setAddDevice(!addDevice);
  }
  useEffect(() => {
    if (item.devices) {
      setCallRoute(item);
      setDevices(item.devices)
    }
  }, [item.devices]);



  function addTDevice(deviceInfo) {
    deviceInfo.forEach(device => {
      deviceAppend(device);

    });

    toggleAddDevice()
  }

  function deleteDevice(e, devIndex) {
    //alert("delete")
    e.preventDefault();
    if (deviceFields.length === 1) {
      deviceRemove(devIndex);
      onDelSeq(e, { seqIndex }, item);
      for (let i = seqIndex; i < (size - 1); i++) {
        setValue(`sequences.${i}.name`, `seq${(i + 1)}`, { shouldDirty: true });
      }
    } else {
      deviceRemove(devIndex);
    }


  }

  useEffect(() => {
    if (isadd) {
      if (seqIndex === 0 && deviceFields.length === 0) {
        setAllowSaveFlag(true);
      } else {
        setAllowSaveFlag(false);
      }

    }
    // alert(JSON.stringify(deviceFields));

  }, [deviceFields])




  function handleSequence(e, taction, deleteObj) {
    setIsOpen(false)
    e.preventDefault();
    const devicelist = item.devices.length > 0 ? [...item.devices] : [...deviceFields];
    const modifiedObj = {
      ...(({ id, deviceid, ...rest }) => rest)(item),
      devices: devicelist.map(device => ({ ...device, newDevice: true, deviceid: "" }))
    };
    modifiedObj.newSeq = true;
    if (taction === 2) {
      modifiedObj.name = `seq${size + 1}`;
    } else if (taction === 1) {
      modifiedObj.name = `seq${seqIndex + 2}`;
      for (let i = (seqIndex + 1); i < size; i++) {
        setValue(`sequences.${i}.name`, `seq${(i + 2)}`, { shouldDirty: true });
      }
    }
    modifiedObj.oldseq = "";
    console.log("value is after after::::::: " + JSON.stringify(modifiedObj));
    switch (taction) {
      case 1:
        onCloneSeq(e, modifiedObj, seqIndex);
        break;
      case 2:
        onCloneSeqEnd(e, modifiedObj);
        break;
      case 3:
        setEMessage("");
        setemptyDeviceIndex([]);
        onDelSeq(e, { seqIndex }, deleteObj);
        for (let i = seqIndex; i < (size - 1); i++) {
          setValue(`sequences.${i}.name`, `seq${(i + 1)}`, { shouldDirty: true });
        }
        break
    }


  }

  return (
    <>


      <div className={`seq-bg ${emptyDeviceIndex.includes(seqIndex + 1) ? "seq-err-bg" : ""}`}>
        <div className="d-flex align-items-center justify-content-between p-2">
          <h5 className='m-0'>{t("sequence")} {seqIndex + 1}</h5>
          <div className="d-flex">
            <button className='seq-header-btn me-2'
              onClick={(e) => {
                e.preventDefault();
                let updateEmptyDeviceList = [...emptyDeviceIndex];
                updateEmptyDeviceList.splice(emptyDeviceIndex.indexOf(seqIndex + 1), 1);
                setemptyDeviceIndex(updateEmptyDeviceList);
                if (updateEmptyDeviceList.length === 0) {
                  setEMessage("");
                }
                toggleAddDevice()
              }}
            >
              <MDBIcon fas icon="plus" color='primary' size='lg' />
            </button>

            {!isadd && size < 4 && size > 1 ? (
              <>

                <MDBDropdown disabled >
                  <MDBDropdownToggle tag='button' className='seq-header-btn  border-0 shadow-0'>
                    <MDBIcon fas icon='ellipsis-v' color='primary' size='lg' />
                  </MDBDropdownToggle>
                  <MDBDropdownMenu >
                    <MDBDropdownItem link onClick={(e) => handleSequence(e, 1, null)}>Insert cloned Sequence</MDBDropdownItem>
                    <MDBDropdownItem link onClick={(e) => handleSequence(e, 2, null)}>Clone sequence and move to the end</MDBDropdownItem>
                    <MDBDropdownItem link onClick={(e) => handleSequence(e, 3, item)}>Delete Sequence</MDBDropdownItem>
                  </MDBDropdownMenu>
                </MDBDropdown>
              </>
            )
              : (isadd && size <= 4 || size == 4) ? (
                <>

                  <MDBDropdown >
                    <MDBDropdownToggle tag='button' className='seq-header-btn  border-0 shadow-0'>
                      <MDBIcon fas icon='ellipsis-v' color='primary' size='lg' />
                    </MDBDropdownToggle>
                    <MDBDropdownMenu open={isOpen}>
                      <MDBDropdownItem link onClick={(e) => handleSequence(e, 3, item)}> Delete Sequence</MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </>
              ) : (!isadd && size === 1 && (<>

                <MDBDropdown disabled >
                  <MDBDropdownToggle tag='button' className='seq-header-btn  border-0 shadow-0'>
                    <MDBIcon fas icon='ellipsis-v' color='primary' size='lg' />
                  </MDBDropdownToggle>
                  <MDBDropdownMenu >
                    <MDBDropdownItem link onClick={(e) => handleSequence(e, 1, null)}>Insert cloned Sequence</MDBDropdownItem>
                    <MDBDropdownItem link onClick={(e) => handleSequence(e, 2, null)}>Clone sequence and move to the end</MDBDropdownItem>
                  </MDBDropdownMenu>
                </MDBDropdown>
              </>
              ))}
          </div>
        </div>

        <MDBCard className='mt-2 p-0 rounded-3'>
          <MDBCardBody className='p-0 rounded-3 pt-3'>
            <div className="position-relative px-2 mb-2">
              <MDBInput label='Ring Time' id='form1' type='text'
                // disabled={issystemroute}
                //  value={getValues(`sequences.${seq}.ringtime`)}
                value={watch(`sequences.${seqIndex}.ringtime`)}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onChange={(e) => {
                  setValue(`sequences.${seqIndex}.ringtime`, e.target.value, { shouldDirty: true });
                  clearErrors(`sequences.${seqIndex}.ring_secs`);
                }}
              />
              <span class="seconds ">Seconds</span>
            </div>
            {errors?.sequences?.[seqIndex]?.ring_secs && (
              <p className="text-danger">
                {errors.sequences?.[seqIndex].ring_secs.message}
              </p>
            )}

            {/* <div className="border-bottom border border-dashed my-2" /> */}


            {deviceFields &&
              deviceFields.map((deviceField, deviceIndex) => (
                <>
                  <div key={deviceField.id}>
                    <CallRouteDevice
                      ditem={deviceField}
                      seqindex={seqIndex}
                      // issystemroute={issystemroute}
                      ondelete={deleteDevice}
                      deviceindex={deviceIndex}
                      register={register}
                      getValues={getValues}
                      setValue={setValue}
                      deviceLength={deviceFields.length}
                      setAllowSaveFlag={setAllowSaveFlag}
                      isadd={isadd}
                      callerids={callerids}
                      isDisabled={isDisabled}
                      watch={watch}
                      size={size}
                    />
                  </div>
                  <div className="dashed-devied m-2" />

                </>
              ))}



            {/* <div className="border-bottom border border-dashed my-3" /> */}


            {/* <div>
              <div className='mt-3 mb-2'>
                <div className="d-flex align-items-center justify-content-between">
                  <p className='text-primary fw-500 seq-name_ellipsis' title='Mobile Softphone'>
                    <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                    Mobile Softphone
                  </p>
                  <div className="d-flex align-items-center">
                    <MDBCheckbox name='inlineCheck' id='inlineCheckbox1' value='option1' />
                    <label htmlFor="inlineCheckbox1" className='cursor-pointer'>All Day</label>
                    <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                      <MDBIcon fas icon="times" color='danger' size='md' />
                    </button>
                  </div>
                </div>
              </div>

              <MDBInputGroup className='mt-2'>
                <div style={{ width: "50%" }}>
                  <MDBTimepicker inputLabel='From' inline />
                </div>
                <div style={{ width: "50%" }}>
                  <MDBTimepicker inputLabel='To' inline />
                </div>
              </MDBInputGroup>
            </div> */}


            {/* <div className="border-bottom border border-dashed my-3" />


            <div>
              <div className='mt-3 mb-2'>
                <div className="d-flex align-items-center justify-content-between">
                  <p className='text-primary fw-500 seq-name_ellipsis'>
                    <MDBIcon color='secondary' fas icon="desktop" className="me-2" />
                    IP Phone 2
                  </p>
                  <div className="d-flex align-items-center">
                    <MDBCheckbox name='inlineCheck' id='inlineCheckbox2' value='option1' />
                    <label htmlFor="inlineCheckbox2" className='cursor-pointer'>All Day</label>
                    <button className='seq-close-btn bg-danger bg-opacity-25 ms-2'>
                      <MDBIcon fas icon="times" color='danger' size='md' />
                    </button>
                  </div>
                </div>
              </div>

              <MDBInputGroup className='mt-2'>
                <div style={{ width: "50%" }}>
                  <MDBTimepicker inputLabel='From' inline />
                </div>
                <div style={{ width: "50%" }}>
                  <MDBTimepicker inputLabel='To' inline />
                </div>
              </MDBInputGroup>
            </div> */}




          </MDBCardBody>
        </MDBCard>

      </div>












      {/* <div className={`sequence ${emptyDeviceIndex.includes(seqIndex + 1) ? "border-danger" : ""}`}> */}
      {/* <div className="sequenceheader">
          <span className="d-flex align-items-center">
            <label className="fw-bold fs-5">{t("sequence")} {seqIndex + 1}</label>
            <MDBBtn
              size="sm"
              className="buttonsize mx-2"
              // disabled={issystemroute}
              onClick={(e) => {
                e.preventDefault();
                let updateEmptyDeviceList = [...emptyDeviceIndex];
                updateEmptyDeviceList.splice(emptyDeviceIndex.indexOf(seqIndex + 1), 1);
                setemptyDeviceIndex(updateEmptyDeviceList);
                if (updateEmptyDeviceList.length === 0) {
                  setEMessage("");
                }
                toggleAddDevice()
              }}
            >
              <MDBIcon fas icon="plus" size="sm" /> {t("addDevice")}
            </MDBBtn>
          </span>

          {!isadd && size < 4 && size > 1 ? (
            <>
              <MDBBtnGroup
                aria-label="Button group with nested dropdown"
                className="display-inline btn-sm btn_adjust h-inherit" >
                <MDBBtnGroup
                // disabled={(isadd || issystemroute ? true : false)}

                >
                  <MDBDropdown disabled >
                    <MDBDropdownToggle className="px-3"
                    //  disabled={issystemroute}
                    // disabled={(isadd || issystemroute ? true : false)}
                    >
                      <MDBIcon fas icon="ellipsis-v" />
                    </MDBDropdownToggle>
                    <MDBDropdownMenu >
                      <MDBDropdownItem link onClick={(e) => handleSequence(e, 1, null)}>Insert cloned Sequence</MDBDropdownItem>
                      <MDBDropdownItem link onClick={(e) => handleSequence(e, 2, null)}>Clone sequence and move to the end</MDBDropdownItem>
                      <MDBDropdownItem link onClick={(e) => handleSequence(e, 3, item)}>Delete Sequence</MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBBtnGroup>
              </MDBBtnGroup>
            </>
          )
            : (isadd && size <= 4 || size == 4) ? (
              <>
                <MDBBtnGroup
                  aria-label="Button group with nested dropdown"
                  className="display-inline me-3 btn_adjust h-inherit"
                // disabled={issystemroute}
                >
                  <MDBBtnGroup open={isOpen} toggle={toggleDropdown}
                  // disabled={issystemroute}
                  >
                    <MDBDropdown >
                      <MDBDropdownToggle className="px-3" open={isOpen}
                      // disabled={issystemroute}
                      >
                        <MDBIcon fas icon="ellipsis-v" />
                      </MDBDropdownToggle>
                      <MDBDropdownMenu open={isOpen}>
                        <MDBDropdownItem link onClick={(e) => handleSequence(e, 3, item)}> Delete Sequence</MDBDropdownItem>
                      </MDBDropdownMenu>
                    </MDBDropdown>
                  </MDBBtnGroup>
                </MDBBtnGroup>
              </>
            ) : (!isadd && size === 1 && (<>
              <MDBBtnGroup
                aria-label="Button group with nested dropdown"
                className="display-inline btn-sm btn_adjust h-inherit" >
                <MDBBtnGroup
                // disabled={(isadd || issystemroute ? true : false)}

                >
                  <MDBDropdown disabled >
                    <MDBDropdownToggle className="px-3"
                    //  disabled={issystemroute}
                    // disabled={(isadd || issystemroute ? true : false)}
                    >
                      <MDBIcon fas icon="ellipsis-v" />
                    </MDBDropdownToggle>
                    <MDBDropdownMenu >
                      <MDBDropdownItem link onClick={(e) => handleSequence(e, 1, null)}>Insert cloned Sequence</MDBDropdownItem>
                      <MDBDropdownItem link onClick={(e) => handleSequence(e, 2, null)}>Clone sequence and move to the end</MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBBtnGroup>
              </MDBBtnGroup>
            </>
            ))}
        </div> */}
      {/* <div className="ringtime ">
          <label>{t("RingTime")}</label>
          <span className="position-relative">
            <MDBInput
              id="form1"
              type="text"
              size="sm"
              // disabled={issystemroute}
              //  value={getValues(`sequences.${seq}.ringtime`)}
              value={watch(`sequences.${seqIndex}.ringtime`)}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onChange={(e) => {
                setValue(`sequences.${seqIndex}.ringtime`, e.target.value, { shouldDirty: true });
                clearErrors(`sequences.${seqIndex}.ring_secs`);
              }}
            />

            <span className="seconds">{t("seconds")}</span>
            {errors?.sequences?.[seqIndex]?.ring_secs && (
              <p className="text-danger">
                {errors.sequences?.[seqIndex].ring_secs.message}
              </p>
            )}
          </span>
        </div> */}
      {/* {deviceFields &&
          deviceFields.map((deviceField, deviceIndex) => (
            <>
              <div key={deviceField.id}>
                <CallRouteDevice
                  ditem={deviceField}
                  seqindex={seqIndex}
                  // issystemroute={issystemroute}
                  ondelete={deleteDevice}
                  deviceindex={deviceIndex}
                  register={register}
                  getValues={getValues}
                  setValue={setValue}
                  deviceLength={deviceFields.length}
                  setAllowSaveFlag={setAllowSaveFlag}
                  isadd={isadd}
                  callerids={callerids}
                  isDisabled={isDisabled}
                  watch={watch}
                  size={size}
                  errors={errors}
                  clearErrors={clearErrors}
                  unregister={unregister}
                />
              </div>
            </>
          ))} */}
      {/* </div> */}
      {addDevice && (
        <PopupLoaderNew
          size="md"
          className="modal-md"
          title="Add Device"
          content={<AddCRDevice
            addDevice={addTDevice}
            devIndex={seqIndex}
            setDevIndex={setDevIndex}
            isadd={isadd}
            deviceExternalNum={deviceExternalNum}
            callerids={callerids}
            onClose={toggleAddDevice}
            deviceFields={deviceFields}
            ref={addDeviceRef}
            setIsloading={setisLoading}
          />}
          onShow={setAddDevice}
          onClose={toggleAddDevice}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}
        />
      )}
    </>
  );
}
